import el from './call-out.svelte';
if (!customElements.get("call-out")) {
    customElements.define("call-out", el);
}
else {
    console.warn("Skipping re-defining customElement call-out");
}
